'use strict';

var processInclude = require('theme/js/util');

$(document).ready(function () {
    processInclude(require('theme/js/giftcertificate/giftcertificates'));
});
